"use strict";

exports.__esModule = true;
var _AppSidebar = require("./AppSidebar");
Object.keys(_AppSidebar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppSidebar[key]) return;
  exports[key] = _AppSidebar[key];
});